import { useState } from 'react';
import Media from 'react-media';
import { useTracking } from 'react-tracking';
import { push } from 'redux-first-router';
import { getPath } from '@/router/utils';
import loadable from '@loadable/component';

import { Button, useTheme, Grid, Heading, Text } from '@simplywallst/ui-core';

import { PlusSolid } from '@simplywallst/ui-core/icons';

import { ROUTE_DEPRECATED_IMPORT_PORTFOLIO } from '@/constants/routes';

const CreateManualPortfolioModal = loadable(
  () => import('../CreateManualPortfolioModal'),
  {
    resolveComponent: (c) => c.CreateManualPortfolioModal,
  }
);

export const CreateLegacyManualPortfolio = () => {
  const { trackEvent } = useTracking({ type: 'track' });
  const theme = useTheme();
  const [state, setState] = useState<'open' | 'close'>('close');
  return (
    <>
      <Heading as="h3" typography="baseStrong" textAlign="center">
        Track your holdings manually
      </Heading>
      <Text
        typography="xSmall"
        color="whiteRGBA"
        opacity={0.5}
        textAlign="center"
      >
        Add your holdings information or transactions using the legacy
        portfolio. New version coming soon.
      </Text>
      <Grid justifyContent="center">
        <Media query={{ minWidth: theme.lgMinRaw }}>
          {(match) => {
            return match && RUNTIME_ENV !== 'native' ? (
              <Button
                styleType="loudLarge"
                alignIcon="left"
                onClick={() => {
                  push(
                    getPath({
                      type: ROUTE_DEPRECATED_IMPORT_PORTFOLIO,
                      payload: {},
                    })
                  );

                  trackEvent({
                    action: 'click',
                    subject: 'Create Portfolio',
                  });
                }}
              >
                <PlusSolid />
                Create Portfolio
              </Button>
            ) : (
              <Button
                styleType="loudLarge"
                alignIcon="left"
                onClick={() => setState('open')}
              >
                <PlusSolid />
                Create Portfolio
              </Button>
            );
          }}
        </Media>
      </Grid>
      {state === 'open' ? (
        <CreateManualPortfolioModal onClose={() => setState('close')} />
      ) : null}
    </>
  );
};
